<template>
	<body>
		<div class="half-screen">
			<table v-if="editIndex==null">
				<thead>
					<tr>
						<th>Preview</th>
						<th>Download</th>
						<th>Edit</th>
						<th>File Name</th>
						<th>Html</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(data, col) in pageData" :class="{selected:previewIndex==col}">
						<td>
							<button v-on:click="preview(col)">Preview</button>
						</td>
						<td>
							<button v-on:click="download(col)">Download</button>
						</td>
						<td>
							<button v-on:click="edit(col)">Edit</button>
						</td>
						<td>
							<p>{{data[0]}}</p>
						</td>
						<td>
							<p>{{data[1]}}</p>
						</td>
					</tr>
				</tbody>
			</table>
			<div v-else>
				<button v-on:click="edit(null)">Back</button>
				<b>Editing</b>
				<br/>
				<input v-model="editFileName"></input>

				<b-form-file
		            class="upload-box text-nowrap text-truncate"
		            size="lg"
		            v-model="editHtml"
		            :state="Boolean(editHtml)"
		            placeholder="Choose or Drop file here"
		            drop-placeholder="Drop files here"
					@input="editPreview()"
		        ></b-form-file>

				<button v-on:click="save()">Save</button>
			</div>
		</div>
		<div class="half-screen">
			<iframe style="width:100%; flex: 1;" v-if="previewIndex!=null" ref="previewHtml"></iframe>
		</div>
	</body>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
import { nextTick } from 'vue';
export default {
    props: {
		term: '',
    },
	data(){
		return{
			pageid:PAGES.EDIT_WEBSITE_PAGE,
			pageData:[],
			previewIndex:null,
			editIndex:null,
			editFileName:"",
			editHtml:null,
		}
	},
	async created () {
        this.search();
    },
	methods:{
		async search() {
            api.postData(
                {
                    type:"search",
                    data:{
                        pageid:this.pageid,
                    }
                }
            ).then((res) => {
				if(res.data!=null){
					this.pageData = res.data;
				}
            });
        },
		preview (index) {
			this.previewIndex = index;
			if(index==null) return;

            nextTick(() => {
                const frame = this.$refs.previewHtml;
                if (frame) {
                    const frameDoc = frame.contentDocument || frame.contentWindow.document;
                    frameDoc.open();
                    frameDoc.write(this.pageData[this.previewIndex][1]);
                    frameDoc.close();
                }
            });
		},
		download (index) {
			var filename = this.pageData[index][0];
			var text = this.pageData[index][1];
			var element = document.createElement('a');
			element.setAttribute('href', 'data:text/html;charset=utf-8,' + encodeURIComponent(text));
			element.setAttribute('download', filename);

			element.style.display = 'none';
			document.body.appendChild(element);

			element.click();

			document.body.removeChild(element);
		},
		edit (index) {
			this.editHtml = null;
			this.preview(index);
			this.editIndex = index;
			if(index!=null) {
				this.editFileName = this.pageData[index][0];
			}
		},
		async editPreview() {
			var text = await this.readFile(this.editHtml);

			nextTick(() => {
				const frame = this.$refs.previewHtml;
				if (frame) {
					const frameDoc = frame.contentDocument || frame.contentWindow.document;
					frameDoc.open();
					frameDoc.write(text);
					frameDoc.close();
				}
			});

			this.editFileName = this.editHtml.name;
		},
		readFile (file) {
			return new Promise((resolve, reject) => {
		        var reader = new FileReader();

		        reader.onload = function () {
		            resolve(reader.result);
		        };

		        reader.onerror = function () {
		            reject(new Error("Error reading file"));
		        };

		        reader.readAsText(file);
		    });
		},
		async save () {
			var text = "";
			if(this.editHtml!= null) {
				text = await this.readFile(this.editHtml);
			}

			api.postData(
				{
					type:"insert",
					data:{
						pageid: this.pageid,
						newHtml: text,
						newName: this.editFileName,
						origName: this.pageData[this.editIndex][0],
					}
				}
			).then((res) => {
				alert("Saved "+this.editFileName);
			}).finally(() => {
				this.edit(null);
			});

		},
	}
}
</script>

<style scoped>
template, body {
	height: calc(100vh - 52px);
	margin: 0;
	display: flex;
}

.half-screen {
	height: 100%;
	width:50%;
	overflow-y: auto;
	padding: 5px;
	border: 1px solid gray;
	position: relative;
	box-sizing: border-box;
}

table {
	width: 100%;
	border-collapse: collapse;
}
th, td {
	padding: 4px;
	text-align: left;
	border: 1px solid #bbb;
}

.selected {
	background-color: #ddd;
}

</style>



// WEBPACK FOOTER //
// src/components/edit/Edit_Website.vue